import kfc from "../../src/images/projects/kfc.png";
import yoox from "../../src/images/projects/yoox.PNG";
import ketto from "../../src/images/projects/ketto.png";
const projects = [
  {
    id: 1,
    title: "Yoox_clone",
    subheading: "Women | Fashion",
    description:
      "A simple web application designed for designer products from Yoox. YOOX Net-a-Porter Group S.p.A. is an Italian online fashion retailer, located in Milan, Italy.An individual project completed in 6 days.",
    stack: ["HTML", "CSS", "JavaScript"],
    github: "https://github.com/rsiree/Yoox",
    demo: "https://yoox-fashion.netlify.app/",
    image: yoox,
  },
  {
    id: 2,
    title: "KFC_clone",
    subheading: "Food Ordering Website",
    description:
    "A simple web application to order or pickup delivery or book for dining. A collaborative project built by a team of 5 and executed in 6 days.",
    stack: ["HTML", "CSS", "JavaScript","React","NodeJs","MongoDb","Express"],
      github: "https://github.com/amar0020/kfc",
    demo: "https://kfc-india-clone.netlify.app/",
    image: kfc,
  },
  {
    id: 3,
    title: "Ketto_clone",
    subheading: "Crowd fundraising website",
    description:
    "A donation and fund raising website for varios causes, lending a helping hand for the needy.",
    stack: ["HTML", "CSS", "JavaScript","React","Redux","NodeJs","MongoDb","Express"],
      github: "https://github.com/rsiree/racial-lip-1108",
    demo: "https://ketto.netlify.app/",
    image: ketto,
  },

];

export default projects;
